import { combineReducers } from "redux";

import userReducer from "./users/reducer";
import cartReducer from "./cart/reducer";
import marketplaceReducer from "./marketplaceRequest/reducer";

const reducers = combineReducers({
  userReducer,
  cartReducer,
  marketplaceReducer,
});

export default reducers;
